import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import PaymentStatusLabel from '#client/components/PaymentStatusLabel';
import CardUsed from '#client/components/TransactionDetailModal/components/CardUsed';
import FieldDetail from '#client/components/TransactionDetailModal/components/FieldDetail';
import MoneyDetail from '#client/components/TransactionDetailModal/components/MoneyDetail';
import { DATE_FORMAT } from '#client/constants/date';

export default function AuthorizationDetail({
  amount,
  createdAt,
  type,
  id,
  status,
  reason,
  cardId
}) {
  const createdAtText = dayjs(createdAt).format(DATE_FORMAT.MOVE_MONEY);
  const typeText = type === 'authorization' ? 'Authorization' : type;

  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', md: '56px' }}
      pt={{ xs: '24px', md: '32px' }}
      px={{ xs: '24px', md: '32px' }}
      rowSpacing={{ xs: '16px', md: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            Transaction details
          </Text>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <MoneyDetail
            label="Amount"
            value={amount}
          />
        </Grid>
      </Grid>
      <FieldDetail
        label="Date Initiated"
        value={createdAtText}
      />
      <FieldDetail
        label="Transfer type"
        value={typeText}
      />
      <FieldDetail
        label="ID"
        value={id}
      />
      {status && (
        <Grid
          item
          md={4}
          xs={12}
        >
          <Stack
            direction="column"
            gap="8px"
          >
            <Text
              color="tertiary"
              size="xs"
              uppercase
            >
              Status
            </Text>
            <PaymentStatusLabel status={status} />
          </Stack>
        </Grid>
      )}
      <FieldDetail
        label="Reason"
        value={reason}
      />
      <CardUsed cardId={cardId} />
    </Grid>
  );
}

AuthorizationDetail.propTypes = {
  amount: PropTypes.string,
  createdAt: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  status: PropTypes.string,
  reason: PropTypes.string,
  cardId: PropTypes.string
};
